import { compose, path, pick } from 'ramda';

import {
  MessageTitleAndContent,
  SuccessAndFailureBodyText,
} from '../../../shared/types/cms-frequently-used-shapes';
import { BodyText } from '../../body-text-container/types';

export const unwrapBodyTextHierarchy: <T extends SuccessAndFailureBodyText>(
  input: T['successMessage'] | T['failureMessage'],
) => MessageTitleAndContent = compose(
  pick(['content', 'title']),
  path<BodyText>([0, 'data', 'bodyText', 0]),
);
